import React from 'react'
import styled from 'styled-components'
import { useTable } from 'react-table'
import {FormattedMessage} from "react-intl";

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`

function Table({ columns, data ,selectItem,username,userrole}) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })
  // Render the UI for your table
  return (
    <div className="tablewrapper">
      <table {...getTableProps()} >
        <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            <th>Select</th>
            {headerGroup.headers.map(column =>(
              <th {...column.getHeaderProps()} style={{textAlign: 'center'}}>

                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
        </thead>
        <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row)
          return (
            <tr {...row.getRowProps()}>
              <td>
                <input style={{width:'auto'}} type="radio" name="radio1" value={data[i]} onChange={()=>{selectItem(data[i]);}}
                />
              </td>
              {row.cells.map(cell => {
                if(cell.value === 'Assessment'){
                  return <td {...cell.getCellProps()}>Analyzer</td>
                }
                else if(cell.value === 'FreeAssessment'){
                  return <td {...cell.getCellProps()}>Free Analyzer</td>
                }
                else{
                  if(cell.column.Header === 'Reference ID' || cell.column.Header === 'Project Name' || cell.column.Header === 'Staging Project Name'){
                    return <td style={{textAlign: 'left' }} {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  }else{
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  }
                }


              })}
            </tr>
          )
        })}
        </tbody>
      </table>
    </div>

  )
}

function App(props) {
  let columns;
  if(props.userrole.includes('TRANSLATION_LEAD') || props.userrole.includes('DATA_ENGINEER')){
    columns = React.useMemo(
      () => [
        {
          Header: 'Project Name',
          accessor: 'reponame',
        },
        {
          Header: 'Staging Project Name',
          accessor: 'staging_reponame',
        },
        {
          Header: 'Reference ID',
          accessor: 'reference_id', // accessor is the "key" in the data
        },
        {
          Header: 'Source Language',
          accessor: 'srclang', // accessor is the "key" in the data
        },
        {
          Header: 'Target Language',
          accessor: 'tgtlang', // accessor is the "key" in the data
        },
        {
          Header: 'Job Type',
          accessor: 'job_type', // accessor is the "key" in the data
        },
        {
          Header: 'Job Status',
          accessor: 'job_status', // accessor is the "key" in the data
        },
        {
          Header: 'Source Status',
          accessor: 'sourcestatus', // accessor is the "key" in the data
        }
      ],
      []
    );
  }else{
    columns = React.useMemo(
      () => [
        {
          Header: 'Reference ID',
          accessor: 'referenceId', // accessor is the "key" in the data
        },
        {
          Header: 'Project Name',
          accessor: 'reponame',
        },
        {
          Header: 'Source Language',
          accessor: 'srclang', // accessor is the "key" in the data
        },
        {
          Header: 'Target Language',
          accessor: 'tgtlang', // accessor is the "key" in the data
        },
        {
          Header: 'Job Type',
          accessor: 'jobType', // accessor is the "key" in the data
        },
        {
          Header: 'Job Status',
          accessor: 'jobStatus', // accessor is the "key" in the data
        },
        {
          Header: 'Source Status',
          accessor: 'sourcestatus', // accessor is the "key" in the data
        }
      ],
      []
    );
  }


  // const data2 = React.useMemo(() => makeData(20), [])

  return (
    <Styles>
      <Table columns={columns} data={props.data} selectItem={props.selectItem} username={props.username} userrole={props.userrole}/>
    </Styles>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/table.js